import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useI18n } from "@/i18n/I18nProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

export default function ChangePasswordDialog({ open, onOpenChange }) {
  const { t, lang } = useI18n();
  const [form, setForm] = useState({ old_password: "", new_password: "", confirm: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.new_password !== form.confirm) {
      setError(lang === "it" ? "Le password non coincidono" : "Passwords do not match");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/change-password", { old_password: form.old_password, new_password: form.new_password });
      toast.success(lang === "it" ? "Password aggiornata" : "Password updated");
      onOpenChange(false);
      setForm({ old_password: "", new_password: "", confirm: "" });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader><DialogTitle>{t("change_password")}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label>{t("current_password")}</Label>
            <Input type="password" required value={form.old_password} onChange={(e) => setForm({ ...form, old_password: e.target.value })} data-testid="change-old-password" />
          </div>
          <div>
            <Label>{t("new_password")}</Label>
            <Input type="password" required value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} data-testid="change-new-password" />
          </div>
          <div>
            <Label>{t("confirm_password")}</Label>
            <Input type="password" required value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} data-testid="change-confirm-password" />
          </div>
          {error && <div className="text-sm text-[hsl(0,70%,40%)] bg-[hsl(0,90%,94%)] border rounded-md px-3 py-2">{error}</div>}
          <DialogFooter>
            <Button type="submit" disabled={loading} className="rounded-full btn-lift" data-testid="change-password-submit">{loading ? "…" : t("save")}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
